import React, { useEffect, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useGoogleLogin } from "@react-oauth/google";
import CountrySelect from "../CountrySelect";
import { main_server } from "../../constants";
import { Spotlight } from "../../ui/spotlight";
import { Sparkels } from "../";
import styles from "./index.module.css";

const Register = (props) => {
  const login = useGoogleLogin({
    
    onSuccess: async (codeResponse) => {
      const response = await fetch(
        main_server + "google_user",
        {
          method: "PUT",
          headers: {
            "Content-Type": "text/plain",
          },
          body: JSON.stringify({
            token: codeResponse.access_token,
            rtl: false,
          }),
        },
      );
      const content = await response.text();
      if (response.status === 200) {
        console.log(content);
        localStorage.setItem("chesscloud-token", content);
        document.cookie = `chesscloud-token=${content}; domain=.chessmind.io; path=/; max-age=31536000`;
        window.location.href = '/';
        } else if (response.status === 403) {
        props.setAlertType(false);
        props.setAlertText("A user with that email address already exists");
        props.setShow(true);
        setTimeout(() => props.setShow(false), 3000);
      }
    },
  });

  useEffect(() => {
    const query = window.location.search;
    if (query.includes('?mail=')) {
      setMail(query.split('?mail=')[1]);
    }
    document.body.classList.add('darkMode');
    document.body.classList.add('dark');
  }, []);

  function alert(type, text) {
    props.setAlertType(type);
    props.setAlertText(text);
    props.setShow(true);
    setTimeout(() => props.setShow(false), 3000);
  }

  const [mail, setMail] = useState("");
  const [user, setUser] = useState("");
  const [name, setName] = useState("");
  const [pass, setPass] = useState("");
  const [confirm, setConfirm] = useState("");
  const [agreeTerms, setAgreeTerms] = useState(false);
  const [val, setVal] = useState("");
 // const [phone, setPhone] = useState("");

  const [passValid, setPassValid] = useState(0);
  const [confirmValid, setConfirmValid] = useState(0);
  const [mailValid, setMailValid] = useState(0);
  const [userValid, setUserValid] = useState(0);
  const [nameValid, setNameValid] = useState(0);
 // const [phoneValid, setPhoneValid] = useState(0);
  const [code, setCode] = useState("+972");
  const [capKey, setCapKey] = useState(0);

  return (
    <section className={`${styles.container} absolute top-0 pt-[75px] w-full h-full overflow-y-scroll`}>
      <div className="px-4 mx-auto sm:px-6 lg:px-8 max-w-7xl">
        <div className="max-w-4xl mx-auto">
          <div className={styles.cardWrapper}>
            <Spotlight
              className="-top-40 left-0 md:left-60"
              fill="white"
              active={true}
            />
            <div className={`${styles.card} text-center`}>
              <h1 className={styles.title}>
                {props.lang === 0 ? "יצירת חשבון בחינם" : "Create free account"}
              </h1>
              <Sparkels />
              <p className={styles.subtitle}>
                Unlock the best analysis experience of your life with your new favorite chess platform!
              </p>
              
              <div className="mt-8">
                <button
                  type="button"
                  onClick={() => login()}
                  className={styles.googleButton}
                  style={{ cursor: 'pointer' }}
                >
                  <img
                    className="w-5 h-5"
                    src="https://landingfoliocom.imgix.net/store/collection/clarity-dashboard/images/previews/sign-in/1/google-logo.svg"
                    alt=""
                  />
                  {props.lang === 0 ? "הרשמו עם גוגל" : "Sign up with Google"}
                </button>
              </div>
              
              <div className={styles.divider}>
                <div className="flex justify-center">
                  <span className={styles.dividerText}>
                    {props.lang === 0 ? "או" : "or"}
                  </span>
                </div>
              </div>
              
              <form className="mt-4">
                <div className={styles.formGrid}>
                  {/* Email Field */}
                  <div>
                    <div className={props.lang === 0 && "flex justify-end"}>
                      <label htmlFor="email" className={styles.label}>
                        {props.lang === 0 ? "איימיל" : "Email"}
                      </label>
                    </div>
                    <input
                      type="email"
                      name="email"
                      id="email"
                      onChange={(e) => {
                        setMail(e.target.value);
                        if (e.target.value.length > 0) {
                          if (
                            /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
                              e.target.value,
                            )
                          ) {
                            setMailValid(1);
                          } else {
                            setMailValid(2);
                          }
                        } else setMailValid(0);
                      }}
                      placeholder={
                        props.lang === 0 ? "כתובת איימיל" : "Email address"
                      }
                      value={mail}
                      className={`${styles.input} ${mailValid === 1 ? styles.inputValid : mailValid === 2 ? styles.inputInvalid : ""} ${props.lang === 0 && "text-right"}`}
                    />
                  </div>

                  {/* Full Name Field */}
                  <div>
                    <div className={props.lang === 0 && "flex justify-end"}>
                      <label htmlFor="fullname" className={styles.label}>
                        {props.lang === 0 ? "שם מלא" : "Full Name"}
                      </label>
                    </div>
                    <input
                      type="text"
                      name="fullname"
                      id="fullname"
                      placeholder={props.lang === 0 ? "שם מלא" : "Full Name"}
                      onChange={(e) => {
                        setName(e.target.value);
                        if (
                          e.target.value.length > 3 &&
                          e.target.value.length < 20
                        ) {
                          setNameValid(1);
                        } else if (e.target.value.length === 0) {
                          setNameValid(0);
                        } else {
                          setNameValid(2);
                        }
                      }}
                      value={name}
                      className={`${styles.input} ${nameValid === 1 ? styles.inputValid : nameValid === 2 ? styles.inputInvalid : ""} ${props.lang === 0 && "text-right"}`}
                    />
                  </div>
                  
                  {/* Username Field */}
                  <div>
                    <div className={props.lang === 0 && "flex justify-end"}>
                      <label htmlFor="username" className={styles.label}>
                        {props.lang === 0 ? "שם משתמש" : "Username"}
                      </label>
                    </div>
                    <input
                      type="text"
                      name="username"
                      id="username"
                      placeholder={props.lang === 0 ? "שם משתמש" : "Username"}
                      onChange={(e) => {
                        setUser(e.target.value);
                        if (
                          e.target.value.length > 2 &&
                          e.target.value.length < 20
                        ) {
                          setUserValid(1);
                        } else if (e.target.value.length === 0) {
                          setUserValid(0);
                        } else {
                          setUserValid(2);
                        }
                      }}
                      value={user}
                      className={`${styles.input} ${userValid === 1 ? styles.inputValid : userValid === 2 ? styles.inputInvalid : ""} ${props.lang === 0 && "text-right"}`}
                    />
                  </div>

                  {/* 
                  <div>
                    <div className={props.lang === 0 && "flex justify-end"}>
                      <label htmlFor="phone" className={styles.label}>
                        {props.lang === 0 ? "מספר טלפון" : "Phone Number"}
                      </label>
                    </div>
                    <div className={styles.phoneInput}>
                      <CountrySelect setTarget={setCode} />
                      <input
                        type="tel"
                        name="phone"
                        id="phone"
                        placeholder={props.lang === 0 ? "מספר טלפון" : "Phone Number"}
                        value={phone}
                        onChange={(e) => {
                          const length = e.target.value.length - 1;
                          const char = e.target.value.charAt(length);
                          if (isNaN(char - parseFloat(char))) {
                            if (e.target.value.length > 0) {
                              setPhone(e.target.value.substring(0, length));
                            } else {
                              setPhone("");
                            }
                          } else {
                            setPhone(e.target.value);
                          }

                          setPhoneValid(0);
                          if (
                            /^(?:[0-9\-\\(\\)\\/.]\s?){6,15}[0-9]{1}$/.test(
                              e.target.value,
                            )
                          ) {
                            setPhoneValid(1);
                          } else {
                            setPhoneValid(2);
                          }
                        }}
                        className={`${styles.input} flex-1 ${phoneValid === 1 ? styles.inputValid : phoneValid === 2 ? styles.inputInvalid : ""} ${props.lang === 0 && "text-right"}`}
                      />
                    </div>
                  </div>
*/}
                  {/* Password Field */}
                  <div>
                    <div className={props.lang === 0 && "flex justify-end"}>
                      <label htmlFor="password" className={styles.label}>
                        {props.lang === 0 ? "סיסמא" : "Password"}
                      </label>
                    </div>
                    <input
                      type="password"
                      name="password"
                      id="password"
                      placeholder={
                        props.lang === 0
                          ? "לפחות 8 תווים, אות קטנה, גדולה וסימן"
                          : "min. 8 characters, uppercase, lowercase and a sign"
                      }
                      value={pass}
                      onChange={(e) => {
                        setPass(e.target.value);
                        if (e.target.value.length > 0) {
                          const re =
                            /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()+=-\?;,./{}|\":<>\[\]\\\' ~_]).{8,}/;
                          if (re.test(e.target.value)) {
                            setPassValid(1);
                          } else {
                            setPassValid(2);
                          }
                          if (confirm.length > 0) {
                            if (e.target.value === confirm) {
                              setConfirmValid(1);
                            } else {
                              setConfirmValid(2);
                            }
                          }
                        } else {
                          setPassValid(0);
                        }
                      }}
                      className={`${styles.input} ${passValid === 1 ? styles.inputValid : passValid === 2 ? styles.inputInvalid : ""} ${props.lang === 0 && "text-right"}`}
                    />
                  </div>

                  {/* Confirm Password Field */}
                  <div>
                    <div className={props.lang === 0 && "flex justify-end"}>
                      <label htmlFor="confirm-password" className={styles.label}>
                        {props.lang === 0 ? "אישור סיסמא" : "Confirm Password"}
                      </label>
                    </div>
                    <input
                      type="password"
                      name="confirm-password"
                      id="confirm-password"
                      placeholder={
                        props.lang === 0 ? "אישור סיסמא" : "Confirm Password"
                      }
                      value={confirm}
                      onChange={(e) => {
                        setConfirm(e.target.value);
                        if (e.target.value.length > 0) {
                          if (e.target.value === pass) {
                            setConfirmValid(1);
                          } else {
                            setConfirmValid(2);
                          }
                        } else {
                          setConfirmValid(0);
                        }
                      }}
                      className={`${styles.input} ${confirmValid === 1 ? styles.inputValid : confirmValid === 2 ? styles.inputInvalid : ""} ${props.lang === 0 && "text-right"}`}
                    />
                  </div>

                  {/* Terms and Captcha - Full Width */}
                  <div className={`${styles.formGridFull} ${styles.spacingY}`}>
                    <div className="relative flex items-start">
                      <div className="flex items-center h-5">
                        <input
                          type="checkbox"
                          checked={agreeTerms}
                          onChange={() => setAgreeTerms(!agreeTerms)}
                          name="agree-terms"
                          id="agree-terms"
                          className={styles.checkbox}
                        />
                      </div>
                      <div className="ml-3">
                        <label
                          htmlFor="agree-terms"
                          className={styles.checkboxLabel}
                        >
                          {props.lang === 0 ? "אני מסכים ל" : "I agree to the"}{" "}
                          <a
                            href="/terms"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.link}
                            style={{ cursor: 'pointer' }}
                          >
                            {props.lang === 0 ? "תנאי השימוש" : "Terms of Use"}
                          </a>{" "}
                          {props.lang === 0 ? "ול" : "and"}{" "}
                          <a
                            href="/privacy"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.link}
                            style={{ cursor: 'pointer' }}
                          >
                            {props.lang === 0 ? "מדיניות הפרטיות" : "Privacy Policy"}
                          </a>
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className={`${styles.formGridFull} ${styles.captchaWrapper}`}>
                    <ReCAPTCHA
                      key={capKey}
                      className={"text-right"}
                      onChange={(e) => {
                        setVal(e);
                      }}
                      sitekey="6Lc3670pAAAAANhR_fYQnuS8a9XtOBvxcVqZ1z3F"
                      theme="dark"
                    />
                  </div>
                  
                  <div className={styles.formGridFull}>
                    <div
                      className={styles.button}
                      style={{ cursor: 'pointer' }}
                      onClick={async (e) => {
                        if (mailValid !== 1) {
                          alert(false, "invalid mail");
                          return;
                        }
                        if (nameValid !== 1) {
                          alert(false, "invalid name");
                          return;
                        }
                        if (userValid !== 1) {
                          alert(false, "invalid user");
                          return;
                        }
                        if (passValid !== 1) {
                          alert(false, "invalid pass");
                          return;
                        }
                        if (confirmValid !== 1) {
                          alert(false, "invalid confirm");
                          return;
                        }
                        if (!agreeTerms) {
                          alert(false, "Please agree to the Terms of Use and Privacy Policy to continue.");
                          return;
                        }
                        if (val.length === 0) {
                          alert(false, "complete captcha");
                          return;
                        }
                        const response = await fetch(
                          main_server + "user",
                          {
                            method: "PUT",
                            headers: {
                              "Content-Type": "text/plain",
                            },
                            body: JSON.stringify({
                              user,
                              pass,
                              name,
                              mail,
                              val,
                            //  phone: code + phone,
                            }),
                          },
                        );
                        const content = await response.text();
                        if (response.status === 200) {
                          document.cookie = `chesscloud-token=${content}; domain=.chessmind.io; path=/; max-age=31536000`;
                          localStorage.setItem("chesscloud-token", content);
                        //  localStorage.setItem("chesscloud-phone", phone);
                          window.location.href = "/";
                        } else if (response.status === 406) {
                          props.setAlertType(false);
                          props.setAlertText(content);
                          props.setShow(true);
                          setTimeout(() => props.setShow(false), 3000);
                          if (content === 'Invalid CAPTCHA') setCapKey(capKey + 1);
                        } else if (response.status === 501) {
                          props.setAlertType(false);
                          props.setAlertText(
                            "Error while sending SMS, please try again later.",
                          );
                          props.setShow(true);
                          setTimeout(() => props.setShow(false), 3000);
                        } else {
                          props.setAlertType(false);
                          props.setAlertText(
                            "Unexpected error, please try again later.",
                          );
                          props.setShow(true);
                          setTimeout(() => props.setShow(false), 3000);
                        }
                      }}
                    >
                      {props.lang === 0 ? "הרשמה" : "Sign up"}
                    </div>
                  </div>
                </div>
              </form>
              
              <div className="mt-6 text-center">
                <p className={styles.checkboxLabel}>
                  {props.lang === 0 ? "כבר רשומים" : "Already have an account?"}
                  {" ? "}
                  <a 
                    href="/login" 
                    title="" 
                    className={styles.link}
                    style={{ fontWeight: 'bold', cursor: 'pointer' }}
                  >
                    {props.lang === 0 ? "התחברו עכשיו" : "Login now"}
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Register;
